"use client";

import { createContext, useContext } from "react";
import type { FUSportsCompetition } from "fansunited-data-layer";

interface CompetitionSliceValue {
    competition: FUSportsCompetition;
    seasonName: string;
    nativeCompetitionId: string;
}

const CompetitionSliceContext = createContext<CompetitionSliceValue | null>(null);

export function CompetitionSliceProvider({
    value,
    children,
}: {
    value: CompetitionSliceValue;
    children: React.ReactNode;
}) {
    return <CompetitionSliceContext.Provider value={value}>{children}</CompetitionSliceContext.Provider>;
}

export function useCompetitionSlice(): CompetitionSliceValue {
    const value = useContext(CompetitionSliceContext);
    if (!value) {
        throw new Error("useCompetitionSlice must be used within a CompetitionSliceProvider");
    }
    return value;
}
